module.exports = __webpack_public_path__ + "static/img/topimg.e19a77f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/story/topimg.png
// module id = KAcv
// module chunks = 0